import './SsoButtons.scss';

// src/components/GoogleLoginButton/GoogleLoginButton.jsx
import { useNavigate } from "react-router-dom";
import { useCurrentUser } from "../../UserProvider";
import { setAuthToken } from "../../utils/api";

export default function SsoButtons() {
  const navigate = useNavigate();
  const { refreshUser } = useCurrentUser();

  const handleLogin = () => {
    const width = 500;
    const height = 600;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2.5;

    const popup = window.open(
      `${process.env.REACT_APP_API_URL}/auth/google/login`,
      "googleLogin",
      `width=${width},height=${height},left=${left},top=${top}`
    );

    const messageHandler = (event) => {
      if (!event.data) return;

      const { access_token, refresh_token, user_id } = event.data;
      if (access_token && refresh_token) {
        setAuthToken({ access_token, refresh_token, user_id });
        refreshUser().then(() => navigate("/jobs"));
        popup?.close();
        window.removeEventListener("message", messageHandler);
      }
    };

    window.addEventListener("message", messageHandler);
  };

  return (
    <button type='button' className="google-login-button" onClick={handleLogin}>
      <img src="/images/google.svg" alt="Google icon" />
      Continue with Google
    </button>
  );
}
